import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { CATEGORY_LABELS } from "../lib/constants";

export default function ArchivePage() {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchPage = useCallback(async (p) => {
        const { data } = await api.get("/archive", { params: { page: p, page_size: 15 } });
        return data;
    }, []);

    useEffect(() => {
        setLoading(true);
        fetchPage(1).then((data) => {
            setItems(data.items);
            setHasMore(data.has_more);
        }).finally(() => setLoading(false));
    }, [fetchPage]);

    const loadMore = async () => {
        const next = page + 1;
        const data = await fetchPage(next);
        setItems((prev) => [...prev, ...data.items]);
        setPage(next);
        setHasMore(data.has_more);
    };

    return (
        <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="archive-page">
            <div className="bg-muted border border-hair p-8 mb-10">
                <span className="font-mono text-xs uppercase tracking-widest text-accent">The Archive</span>
                <h1 className="font-serif text-4xl sm:text-5xl font-black mt-1">Past Editions</h1>
                <p className="mt-3 text-sm text-muted-foreground max-w-xl">
                    Stories older than seven days are moved here. Archived pieces are retained for 30 days before removal.
                </p>
            </div>

            {loading ? (
                <p className="font-mono text-sm text-muted-foreground animate-pulse py-16 text-center">Loading archive…</p>
            ) : items.length === 0 ? (
                <p className="font-mono text-sm text-muted-foreground py-16 text-center" data-testid="archive-empty">The archive is currently empty.</p>
            ) : (
                <>
                    <ul className="border-t border-ink">
                        {items.map((a) => (
                            <li key={a.id} className="border-b border-hair">
                                <Link to={`/article/${a.id}`} data-testid={`archive-item-${a.id}`} className="group flex items-baseline gap-4 py-4 hover:bg-muted transition-colors duration-150 px-2 -mx-2">
                                    <span className="font-mono text-xs text-muted-foreground w-24 shrink-0 hidden sm:block">
                                        {a.published_at ? new Date(a.published_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }) : ""}
                                    </span>
                                    <span className="font-mono text-[10px] uppercase tracking-wider text-accent w-28 shrink-0 hidden md:block">
                                        {CATEGORY_LABELS[a.category] || a.category}
                                    </span>
                                    <span className="font-serif text-lg font-semibold leading-snug group-hover:text-accent transition-colors duration-150">
                                        {a.title}
                                    </span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                    {hasMore && (
                        <div className="mt-12 text-center">
                            <button onClick={loadMore} data-testid="archive-load-more" className="px-10 py-3 border-2 border-ink font-mono text-xs uppercase tracking-widest hover:bg-ink hover:text-white transition-colors duration-150">
                                Load More
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
